<template>
  <v-menu v-model="open" offset-y left nudge-bottom="6" content-class="lang-menu" min-width="240">
    <template #activator="{ on, attrs }">
      <button
        v-bind="attrs"
        type="button"
        class="lang-chip"
        :aria-label="$t('nav_language')"
        aria-haspopup="menu"
        :aria-expanded="String(open)"
        v-on="on"
      >
        <v-icon size="18">mdi-translate</v-icon>
        <span>{{ shortCode }}</span>
      </button>
    </template>
    <div class="lang-pop" role="menu">
      <div class="lang-pop__cap">{{ $t("nav_language") }}</div>
      <button
        v-for="lang in availableLanguages"
        :key="lang.code"
        type="button"
        role="menuitemradio"
        class="lang-pop__row"
        :aria-checked="String(lang.code === $i18n.locale)"
        @click="choose(lang.code)"
      >
        <span>{{ lang.text }}</span>
        <v-icon v-if="lang.code === $i18n.locale" size="18" color="#c2410c">mdi-check</v-icon>
      </button>
    </div>
  </v-menu>
</template>

<script>
import { applyLocale } from "@/utils/siteContext";

export default {
  name: "LanguageChip",
  props: { availableLanguages: { type: Array, default: () => [] } },
  data: () => ({ open: false }),
  computed: {
    // "sr" -> SR, "sr-lat" -> SR·L, "en" -> EN
    shortCode() {
      const code = String(this.$i18n.locale || "");
      return code.toUpperCase().replace(/-LAT$/, "·L");
    },
  },
  methods: {
    choose(code) {
      this.open = false;
      applyLocale(this, code);
    },
  },
};
</script>

<style lang="scss">
.lang-chip {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 40px;
  min-width: 54px;
  padding: 0 10px;
  border: 0;
  border-radius: 12px;
  background: transparent;
  color: #3a2f28;
  font-weight: 700;
  font-size: 0.8rem;
  cursor: pointer;
  justify-content: center;
  &:hover,
  &[aria-expanded="true"] {
    background: #f7f1ed;
  }
  &:focus-visible {
    outline: 2px solid #1d4ed8;
    outline-offset: 1px;
  }
}
.lang-menu {
  border-radius: 16px !important;
  border: 1px solid #e6d9cf;
  background: #fff;
}
.lang-pop {
  padding-bottom: 6px;
  &__cap {
    padding: 12px 14px 6px;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #756559;
  }
  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 40px;
    padding: 6px 14px;
    border: 0;
    background: transparent;
    font-weight: 600;
    font-size: 0.88rem;
    color: #1c1410;
    cursor: pointer;
    &:hover {
      background: #f7f1ed;
    }
  }
}
</style>
